import { useEffect } from 'react';
import { Actions as CoreActions } from '@sitecore-search/core';
import useWidget from './useWidget.js';
import useWidgetVisibility from './useWidgetVisibility.js';
export const dispatchWidgetAppearAction = (dispatch) => {
    dispatch({ type: CoreActions.WIDGET_APPEAR, payload: {} });
};
const useWidgetRef = () => {
    const { options } = useWidget();
    const { visibility: { onInView, onUpdate } = {} } = options;
    const { ref, inView, entry } = useWidgetVisibility();
    useEffect(() => {
        if (inView) {
            onInView && onInView(entry);
        }
        onUpdate && onUpdate(inView, entry);
    }, [inView, entry, onUpdate, onInView]);
    return ref;
};
export default useWidgetRef;
